import { hcpType } from '../util/constants';
import { getConfigValue } from './getConfigValue';

export function getPrescriberTypeLabel(configSection, prescriberType, appState) {
        if (prescriberType === hcpType.Prescriber) {
            return getConfigValue(appState.config?.[configSection]?.ProviderLabel, appState)?.Value;
        }
        if (prescriberType === hcpType.GroupPractice) {
            return getConfigValue(appState.config?.[configSection]?.GroupPracticeLabel, appState)?.Value;
        }
        if (prescriberType === hcpType.GeographyAggregate) {
            return getConfigValue(appState.config?.[configSection]?.GeographyAggregateLabel, appState)?.Value;
        }
        throw new Error(`Invalid argument: unknown prescriberType '${prescriberType}'`);
    }
